import KPICard from "../../surface/KPICard/KPICard";

const KPICardSkeleton = () => <KPICard kpi="Loading" value={0} isLoading />;

export default KPICardSkeleton;
